var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          attrs: {
            size: "mini",
            disabled: _vm.readonly || _vm.disabled,
            icon: "el-icon-plus",
            type: "primary",
            round: "",
          },
          on: { click: _vm.selectOrg },
        },
        [_vm._v(_vm._s(_vm.placeholder))]
      ),
      _vm._v(" "),
      _c("org-items", {
        attrs: { value: _vm.value, closable: !_vm.disabled },
        on: {
          remove: function ($event) {
            return _vm.$emit("input", _vm.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "OrgPicker",
        _vm._b(
          {
            ref: "orgPicker",
            attrs: {
              title: _vm.title,
              showOrgPicker: _vm.isShowDialog,
              checkedData: _vm.userIdList,
              isPersonLevel: true,
              isCheckLeafOnly: _vm.isCheckLeafOnly,
              isSingleCheck: !_vm.multiple,
              isAppendToBody: false,
              isMergeUser: false,
            },
            on: {
              "update:showOrgPicker": function ($event) {
                _vm.isShowDialog = $event
              },
              "update:show-org-picker": function ($event) {
                _vm.isShowDialog = $event
              },
              updateCheckedData: _vm.updateCheckedPerson,
            },
          },
          "OrgPicker",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }